import React, { useRef, useState } from "react";
export interface IProgressBar {
  lSide: JSX.Element;
  rSide: JSX.Element;
  positive: boolean;
  percentage: number;
  parentClass?: string;
  onClick?: Function;
  barBackground?: string;
}
const Progressbar = (props: IProgressBar) => {
  return (
    <>
      {/* negative progress bar  */}

      <div
        className={`col-sm-12 col-md-12 col-xs-12 ${
          props.parentClass ? props.parentClass : ""
        } `}
      >
        <div
          className="progress progresscontainer"
          onClick={() => props.onClick && props.onClick()}
        >
          <div
            className={`progress-bar progressbox ${
              props.onClick && "hand_cursor"
            } ${
              props.positive ? "progress-bar-success" : "progress-bar-negative"
            }`}
            role="progressbar"
            aria-valuenow={40}
            aria-valuemin={0}
            aria-valuemax={100}
            style={{
              width: `${props.percentage}%`,
              backgroundColor: props?.barBackground,
            }}
          ></div>
          <div
            className={`d-flex progressbox ${
              props.onClick && "hand_cursor"
            } stacktop`}
          >
            <div className="ml-13">
              {/* <span className="commondatavalue">Aadani Ports</span>
              <span className="commondatanumber">735.7</span> */}
              {props.lSide}
            </div>
            <div className="ml-auto">
              {/* removed mr-13 not aling with title */}
              {/* <span className="commondatanumberpositive negativeValue">
                +10.35 (+4.40%)
              </span> */}
              {props.rSide}
            </div>
          </div>
        </div>
      </div>

      {/* positive  progress bar 
      <div className="progress progresscontainer">
        <div
          className="progress-bar  progressbox"
          role="progressbar"
          aria-valuenow={40}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{ width: "40%" }}
        ></div>
        <div className="d-flex progressbox stacktop">
          <div className="ml-13">
            <span className="commondatavalue">Aadani Ports</span>
            <span className="commondatanumber">735.7</span>
          </div>
          <div className="ml-auto mr-13">
            <span className="commondatanumberpositive positiveValue">
              +10.35 (+4.40%)
            </span>
          </div>
        </div>
      </div>
      {/* positive  progress bar with streaming values  
      <div className="progress progresscontainer">
        <div
          className="progress-bar progress-bar-success progressbox"
          role="progressbar"
          aria-valuenow={40}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{ width: "60%" }}
        ></div>
        <div className="d-flex progressbox stacktop">
          <div className="ml-13">
            <span className="commondatavalue">Aadani Ports</span>
            <span className="commondatanumberpositive positiveValue">
              {" "}
              <span className="commondatanumber">735.7</span> +10.35 (+4.40%)
            </span>
          </div>
          <div className="ml-auto mr-13">
            <span className="commondatanumber">735.7</span>
          </div>
        </div>
      </div>
      {/* negative  progress bar with streaming values 
      <div className="progress progresscontainer">
        <div
          className="progress-bar progress-bar-negative progressbox"
          role="progressbar"
          aria-valuenow={40}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{ width: "90%" }}
        ></div>
        <div className="d-flex progressbox stacktop">
          <div className="ml-13">
            <span className="commondatavalue">Aadani Ports</span>
            <span className="commondatanumberpositive negativeValue">
              {" "}
              <span className="commondatanumber">735.7</span> +10.35 (+4.40%)
            </span>
          </div>
          <div className="ml-auto mr-13">
            <span className="commondatanumber">735.7</span>
          </div>
        </div>
      </div>
      {/* positive  progress bar without streaming values  
      <div className="progress progresscontainer">
        <div
          className="progress-bar progress-bar-success progressbox"
          role="progressbar"
          aria-valuenow={40}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{ width: "40%" }}
        ></div>
        <div className="d-flex progressbox stacktop">
          <div className="ml-13">
            <span className="commondatavalue">Aadani Ports</span>
          </div>
          <div className="ml-auto mr-13">
            <span className="commondatanumber">735.7</span>
          </div>
        </div>
      </div>
      {/* negative  progress bar with without streaming values  
      <div className="progress progresscontainer">
        <div
          className="progress-bar progress-bar-negative progressbox"
          role="progressbar"
          aria-valuenow={40}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{ width: "40%" }}
        ></div>
        <div className="d-flex progressbox stacktop">
          <div className="ml-13">
            <span className="commondatavalue">Aadani Ports</span>
          </div>
          <div className="ml-auto mr-13">
            <span className="commondatanumber">735.7</span>
          </div>
        </div>
      </div> */}
    </>
  );
};
export default React.memo(Progressbar);
